import UniversalAIGames from '../../../components/Games/UniversalAIGames';

const AdvancedDragDropGames = ({ user }) => {
    return <UniversalAIGames user={user} category="advanced" />;
};

export default AdvancedDragDropGames;
